import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCheckCircleSvg } from "./IconCheckCircleSvg.mjs";
const IconCheckCircle = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCheckCircleSvg, ...iconProps });
};
export {
  IconCheckCircle
};
